import React from 'react'
import Image from '../Image'
import getImageSrc from './helper/getImageSrc'

export default function ImageLoader({
  src,
  source,
  className = null,
  alt = null,
  width = null,
  height = null,
  layout = null,
  fit = null,
  onClick = null,
  style = null,
  cloudinaryParams,
  overrideCloudinary = false,
  noLazyLoad = false,
  forceSize = false,
  ...props
}) {
  if (!source && !src) return null

  const imgSrc = getImageSrc(
    source || src,
    cloudinaryParams,
    overrideCloudinary,
    forceSize,
    height,
    width,
  )

  const lazyLoadClass = className ? `${className} lazyload` : 'lazyload'
  const imageClass = noLazyLoad ? className : lazyLoadClass
  const defaultImage = noLazyLoad ? imgSrc : 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='

  return (
    <Image
      className={imageClass}
      src={defaultImage}
      data-src={imgSrc}
      data-sizes="auto"
      alt={alt}
      width={width}
      height={height}
      layout={layout}
      fit={fit}
      onClick={onClick}
      style={style}
      crossOrigin="anonymous"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  )
}
